//@flow
import api from '../Utils/apiBuilder';
import Constants from '../constants';

export default {
  getMembership() {
    return api('memberships').get().dispatch(Constants.GET_MEMBERSHIP_SUCCESS);
  },

  updateMembership(membershipId:string, membershipInfo:Object) {
    return api('memberships', membershipId).put(membershipInfo).dispatch(Constants.UPDATE_MEMBERSHIP_SUCCESS);
  },

  getMembershipPlans() {
    return api('memberships/plans').noauth().get().dispatch(Constants.GET_MEMBERSHIP_PLANS_SUCCESS);
  },

  createMembership(membershipInfo:Object) {
    return api('memberships')
      .post(membershipInfo)
      .dispatch(Constants.CREATE_MEMBERSHIP_SUCCESS);
  },

  cancelMembership(membershipId:string) {
    return api('memberships', membershipId, 'cancel')
      .post({})
      .dispatch(Constants.CANCEL_MEMBERSHIP_SUCCESS);
  },
};
